import DefaultSidebar from '../../../components/Sidebar/';
import nav from './_nav';

class Sidebar extends DefaultSidebar {
  render() {
    return (
      this.renderDefault(nav.items)
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/views/Surveys/Sidebar/Sidebar.js